import { ComponentPropsWithRef } from "react";
import useDevice from "../hooks/useDevice";

type GridChildProps = ComponentPropsWithRef<"div"> & {
    span?: number
};

function GridChild({
    children,
    span = 1
}: GridChildProps) {

    const device = useDevice();
    const isMobile = device !== 'desktop'
    
    return (
        <div style={{ gridColumn: isMobile ? "span 2" : `span ${span}` }}>
            {children}
        </div>
    )
}

export default GridChild;